import util from '@/helpers/util'

export default {
    inserted: (el, binding) => {

        if (el.nodeName.toUpperCase() === "IMG") {
            el.dataset.src = el.src;
            el.removeAttribute('src');
        }

        if (el.style.backgroundImage) {
            el.dataset.bg = el.style.backgroundImage;
            el.style.backgroundImage = '';
        }


        util.doSomethingOnceVisible(el, () => {

            if (el.dataset.src) {
                el.src = el.dataset.src;
            }

            if (el.dataset.bg) {
                el.style.backgroundImage = el.dataset.bg;
            }

        });
    }
};